import {useContext} from "react";

import {CoeditingUIContext} from "./coediting-ui-context.ts";

export const useCoeditingUI = () => useContext(CoeditingUIContext);
